module.exports = __webpack_public_path__ + "img/KinokoTable26.1cb7424b.jpg";